export const isDemoEnvironment = () => {
  return getRaindropEnvironment() === "DEMO";
};

export const isLocalEnvironment = () => {
  return getRaindropEnvironment() === "LOCAL";
};

export const isProductionEnvironment = () => {
  return getRaindropEnvironment() === "PRODUCTION";
};

export const isStagingEnvironment = () => {
  return getRaindropEnvironment() === "STAGING";
};

export const getRaindropEnvironment = () => {
  const ENVIRONMENT_PRODUCTION = "PRODUCTION";
  const ENVIRONMENT_STAGING = "STAGING";
  const ENVIRONMENT_LOCAL = "LOCAL";

  return {
    "app.theraindropcompany.com": ENVIRONMENT_PRODUCTION,
    "nimbus.theraindropcompany.com": ENVIRONMENT_PRODUCTION,
    "www.theraindropcompany.com": ENVIRONMENT_PRODUCTION,
    "cirrus.theraindropcompany.com": ENVIRONMENT_PRODUCTION,

    "app-staging.theraindropcompany.com": ENVIRONMENT_STAGING,
    "nimbus-staging.theraindropcompany.com": ENVIRONMENT_STAGING,
    "www-staging.theraindropcompany.com": ENVIRONMENT_STAGING,
    "cirrus-staging.theraindropcompany.com": ENVIRONMENT_STAGING,

    localhost: ENVIRONMENT_LOCAL,
  }[window.location.hostname];
};

export const isDomainRaindrop = () => {
  return [
    "app.theraindropcompany.com",
    "app-staging.theraindropcompany.com",
  ].includes(window.location.hostname);
};

export const isDomainCirrus = () => {
  return [
    "cirrus.theraindropcompany.com",
    "cirrus-staging.theraindropcompany.com",
  ].includes(window.location.hostname);
};

export const isDomainNimbus = () => {
  return [
    "nimbus.theraindropcompany.com",
    "nimbus-staging.theraindropcompany.com",
  ].includes(window.location.hostname);
};

export const isDomainStratus = () => {
  return [
    "www.theraindropcompany.com",
    "www-staging.theraindropcompany.com",
  ].includes(window.location.hostname);
};
